import script from "./ColumnGroup.vue?vue&type=script&lang=js"
export * from "./ColumnGroup.vue?vue&type=script&lang=js"

export default script